var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1V11C0 11.5523 0.447715 12 1 12C1.55228 12 2 11.5523 2 11V1ZM15.7071 5.29289L11.4074 0.993164C11.0165 0.602279 10.3827 0.602279 9.99186 0.993164C9.60097 1.38405 9.60097 2.0178 9.99186 2.40869L12.5832 5H6C5.44772 5 5 5.44772 5 6C5 6.55229 5.44772 7 6 7H12.5832L9.99186 9.59131C9.60097 9.9822 9.60097 10.616 9.99186 11.0068C10.3827 11.3977 11.0165 11.3977 11.4074 11.0068L15.7071 6.70711C16.0976 6.31658 16.0976 5.68342 15.7071 5.29289Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.63847f2b7ce8f354eb78e890a7e04387.svg";
export { ForwardRef as ReactComponent };